/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMetricValueDto
 */
export interface CreateMetricValueDto {
    /**
     * Health provider code
     * @type {string}
     * @memberof CreateMetricValueDto
     */
    healthProviderCode: CreateMetricValueDtoHealthProviderCodeEnum;
    /**
     * Metric code
     * @type {string}
     * @memberof CreateMetricValueDto
     */
    metricCode: CreateMetricValueDtoMetricCodeEnum;
    /**
     * Integer value for the metric
     * @type {number}
     * @memberof CreateMetricValueDto
     */
    valueInt?: number;
    /**
     * Float value for the metric
     * @type {number}
     * @memberof CreateMetricValueDto
     */
    valueFloat?: number;
    /**
     * Text value for the metric. For text metrics this is the value itself; for JSON metrics (e.g. 'workouts') it may accompany multiDimValues as a descriptive label such as the workout type; for well-being scores it is the optional note (maximum 2000 characters).
     * @type {string}
     * @memberof CreateMetricValueDto
     */
    valueText?: string;
    /**
     * Multi-dimensional values as JSON
     * @type {object}
     * @memberof CreateMetricValueDto
     */
    multiDimValues?: object;
    /**
     * Start date and time of the measurement
     * @type {Date}
     * @memberof CreateMetricValueDto
     */
    startDate: Date;
    /**
     * End date and time of the measurement (must be after startDate)
     * @type {Date}
     * @memberof CreateMetricValueDto
     */
    endDate: Date;
}


/**
 * @export
 */
export const CreateMetricValueDtoHealthProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type CreateMetricValueDtoHealthProviderCodeEnum = typeof CreateMetricValueDtoHealthProviderCodeEnum[keyof typeof CreateMetricValueDtoHealthProviderCodeEnum];

/**
 * @export
 */
export const CreateMetricValueDtoMetricCodeEnum = {
    StepCounts: 'step-counts',
    Distance: 'distance',
    ActiveCalories: 'active-calories',
    Workouts: 'workouts',
    FloorClimbed: 'floor-climbed',
    HeartRate: 'heart-rate',
    HeartRateVariability: 'heart-rate-variability',
    BloodOxygenSaturation: 'blood-oxygen-saturation',
    RespiratoryRate: 'respiratory-rate',
    RestingHeartRate: 'resting-heart-rate',
    BasalMetabolicRate: 'basal-metabolic-rate',
    BodyTemperature: 'body-temperature',
    BloodPressure: 'blood-pressure',
    BloodGlucose: 'blood-glucose',
    Weight: 'weight',
    Height: 'height',
    WaistCircumference: 'waist-circumference',
    HipCircumference: 'hip-circumference',
    BodyMassIndex: 'body-mass-index',
    BodyFatPercentage: 'body-fat-percentage',
    LeanBodyMass: 'lean-body-mass',
    BoneMass: 'bone-mass',
    SleepAnalysis: 'sleep-analysis',
    SleepStages: 'sleep-stages',
    SleepSessionEvents: 'sleep-session-events',
    TimeInBed: 'time-in-bed',
    SleepTime: 'sleep-time',
    ActualSleepTime: 'actual-sleep-time',
    Nutrition: 'nutrition',
    Calories: 'calories',
    Protein: 'protein',
    Carbohydrates: 'carbohydrates',
    TotalFat: 'total-fat',
    SaturatedFat: 'saturated-fat',
    MonounsaturatedFat: 'monounsaturated-fat',
    PolyunsaturatedFat: 'polyunsaturated-fat',
    Cholesterol: 'cholesterol',
    Micronutrients: 'micronutrients',
    Hydration: 'hydration',
    Menstruation: 'menstruation',
    OvulationTestResults: 'ovulation-test-results',
    WellBeing: 'well-being'
} as const;
export type CreateMetricValueDtoMetricCodeEnum = typeof CreateMetricValueDtoMetricCodeEnum[keyof typeof CreateMetricValueDtoMetricCodeEnum];


/**
 * Check if a given object implements the CreateMetricValueDto interface.
 */
export function instanceOfCreateMetricValueDto(value: object): value is CreateMetricValueDto {
    if (!('healthProviderCode' in value) || value['healthProviderCode'] === undefined) return false;
    if (!('metricCode' in value) || value['metricCode'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function CreateMetricValueDtoFromJSON(json: any): CreateMetricValueDto {
    return CreateMetricValueDtoFromJSONTyped(json, false);
}

export function CreateMetricValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMetricValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'healthProviderCode': json['healthProviderCode'],
        'metricCode': json['metricCode'],
        'valueInt': json['valueInt'] == null ? undefined : json['valueInt'],
        'valueFloat': json['valueFloat'] == null ? undefined : json['valueFloat'],
        'valueText': json['valueText'] == null ? undefined : json['valueText'],
        'multiDimValues': json['multiDimValues'] == null ? undefined : json['multiDimValues'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
    };
}

export function CreateMetricValueDtoToJSON(json: any): CreateMetricValueDto {
    return CreateMetricValueDtoToJSONTyped(json, false);
}

export function CreateMetricValueDtoToJSONTyped(value?: CreateMetricValueDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'healthProviderCode': value['healthProviderCode'],
        'metricCode': value['metricCode'],
        'valueInt': value['valueInt'],
        'valueFloat': value['valueFloat'],
        'valueText': value['valueText'],
        'multiDimValues': value['multiDimValues'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
    };
}

